import { Tooltip } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { colors } from '@lavu-pos/stellar/dist/themes';

const TooltipStyled = withStyles({
	tooltip: {
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '16px',
		letterSpacing: '-0.26px',
		color: `${colors['white']};`,
		backgroundColor: `${colors['purple-solid']};`,
		borderRadius: '3px',
		padding: '8px 12px',
		fontFamily: 'Open Sans, sans-serif',
		'& .title': {
			wordBreak: 'break-all',
		},
	},
})(Tooltip);

export default TooltipStyled;
